import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap, tap} from 'rxjs/operators';
import {LoadAppSettings, StoreAppSettings} from '../actions';
import {of, Subscription} from 'rxjs';
import {AppSettingReq,} from '../../models/account/account.models';
import {GeneralService} from '@app/core/services/general/general.service';
import {Store} from '@ngrx/store';
import {AppState} from '../reducers';

@Injectable()
export class AppSettingEffects {
  subManager = new Subscription();

  constructor(
    private _actions$: Actions,
    private generalService: GeneralService,
    private _store$: Store<AppState>
  ) {}

  loadAppSettings$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(LoadAppSettings),
        map((action) => {
          return action.payload;
        }),
        tap((r) => {}),
        switchMap((req: AppSettingReq) => {
          return this.generalService.getAppSetting(req).pipe(
            tap((payload) => {
              this._store$.dispatch(StoreAppSettings({ payload }));
            }),
            catchError((payload) => {
              return of(null);
            })
          );
        })
      ),
    { dispatch: false }
  );
}
